import React, { useState } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { Collapse } from "reactstrap";
import { Translate } from "react-localize-redux";
import EditProfileModal from "../modals/EditProfileModal/EditProfileModal";
import {
  getContactNumber,
  getFullName,
  getEmail,
  getOccupation,
  getProfDesignations,
  getWorkPlace,
  getPhotoUrl,
  getWebsite,
  getFullAddress,
  getSocialAccount
} from "../../utils/profilePrivacy";
import ContactsTable from "../ContactsTable";
import SocialLink from "../SocialLink";
import GeneralMultiItemDropDown from "../forms/GeneralMultiItemDropDown/GeneralMultiItemDropDown";
import AddContactButton from "../AddContactButton";
import "./styles.scss";

const ContactCard = ({
  profile,
  hasContacts,
  showEdit,
  showShare,
  showAdd,
  showContacts,
  loggedInUser,
  contacts,
  onAdd,
  onRemove,
  isUserLoggedIn,
  showContactAction,
  allowedToViewContacts,
}) => {
  const [collapse, setCollapse] = useState(false);

  const renderSocialAccounts = accounts =>
    accounts &&
    accounts.map(account => {
      return (
        getSocialAccount(profile, loggedInUser, account) && (
          <SocialLink key={`${Math.random()}`} socialItem={account} />
        )
      );
    });

  const toggleCollapse = () => {
    setCollapse(!collapse);
  };

  return (
    <div>
      <div className="contact-card-container">
        <div className="row">
          <div className="col-md-5 col-sm-12 contact-img-container">
            <div
              className="contact-card-img-lg"
              style={{
                backgroundImage: `url(${getPhotoUrl(profile, loggedInUser)})`
              }}
            />
          </div>
          <div className="col-md-7 col-sm-12">
            <div className="row">
              <div className="col-12 profile-edit-add-container">
                <div className="float-right">
                  {showEdit ? (
                    <EditProfileModal
                      buttonClass="contact-card-modal-edit"
                      buttonLabel={<Translate id="Edit" />}
                    />
                  ): (
                    <AddContactButton
                      showButton={loggedInUser.id !== profile.id}
                      contactId={profile.id}
                      contacts={contacts}
                      onAdd={onAdd}
                      onRemove={onRemove}
                      isUserLoggedIn={isUserLoggedIn}
                    />
                  )}
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12 profile-info-align-container">
                <h3 className="search-card-name-text">
                  {getFullName(profile, loggedInUser)}{" "}
                  <span className="prof-designations">
                    {getProfDesignations(profile, loggedInUser)}
                  </span>
                </h3>
              </div>

              {getOccupation(profile, loggedInUser) && (
                <div className="col-12 additional-card-data profile-info-align-container">
                  <p>
                    <span>{getOccupation(profile, loggedInUser)}</span>{" "}
                    <span>
                      {" "}
                      {", "}
                      {getWorkPlace(profile, loggedInUser)}
                    </span>
                  </p>
                </div>
              )}

              <div className="col-12 dropdown-row-container">
                <GeneralMultiItemDropDown
                  itemDetailField="number"
                  staticItemLabel={<Translate id="Phone"/>}
                  itemLabelField="category"
                  renderItemDetail={item =>
                    `${getContactNumber(profile, loggedInUser, item)}`
                  }
                  renderDropDownItemLabel={item =>
                    `${item.category}: ${getContactNumber(
                      profile,
                      loggedInUser,
                      item
                    )}`
                  }
                  items={profile.phone_numbers}
                />
              </div>
              <div className="col-12 text-left dropdown-row-container">
                <GeneralMultiItemDropDown
                  itemDetailField="number"
                  staticItemLabel={<Translate id="Fax"/>}
                  itemLabelField="category"
                  renderItemDetail={item =>
                    `${getContactNumber(profile, loggedInUser, item)}`
                  }
                  renderDropDownItemLabel={item =>
                    `${item.category}: ${getContactNumber(
                      profile,
                      loggedInUser,
                      item
                    )}`
                  }
                  items={profile.fax_numbers}
                />
              </div>
              <div className="col-12 text-left dropdown-row-container">
                <GeneralMultiItemDropDown
                  itemDetailField="address"
                  staticItemLabel={<Translate id="Email"/>}
                  itemLabelField="category"
                  renderDropDownItemLabel={item =>
                    `${item.category}: ${getEmail(profile, loggedInUser, item)}`
                  }
                  items={profile.email_addresses}
                />
              </div>
              <div className="col-12 text-left dropdown-row-container">
                <GeneralMultiItemDropDown
                  staticItemLabel={<Translate id="Address"/>}
                  itemLabelField="category"
                  renderItemDetail={item =>
                    `${item.category}: ${getFullAddress(profile, loggedInUser, item)}`
                  }
                  renderDropDownItemLabel={item =>
                    `${item.category}: ${getFullAddress(profile, loggedInUser, item)}`
                  }
                  items={profile.addresses}
                />
              </div>
              <div className="col-12 text-left dropdown-row-container">
                <GeneralMultiItemDropDown
                  itemDetailField="address"
                  staticItemLabel={<Translate id="Website"/>}
                  renderDropDownItemLabel={item => {
                    const website = getWebsite(profile, loggedInUser, item);
                    return <span
                      className="dropdown-website-link"
                      onClick={() => window.open(website, "_blank")}
                    >
                      {website}
                    </span>;
                  }
                  }
                  items={profile.websites}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row social-row justify-content-flex-start">
          {renderSocialAccounts(profile.social_accounts)}
        </div>

        <br />

        <div className="row">
          <div className="col-6">
            {allowedToViewContacts && hasContacts &&
              showContacts && (
                <h4
                  className="collapse-toggle contacts-toggle"
                  onClick={toggleCollapse}
                >
                  <Translate id="Contacts" />{" "}
                  {collapse ? (
                    <i className="fa fa-caret-up" />
                  ) : (
                    <i className="fa fa-caret-down" />
                  )}
                </h4>
              )}
          </div>
          <div className="col-6">
            {showShare && (
              <NavLink to="/share-card" className="btn btn-primary share-button">
                <Translate id="Share" />
              </NavLink>
            )}
          </div>
        </div>
      </div>

      <Collapse isOpen={collapse} className="contacts-collapse-container">
        <br />
        <ContactsTable contacts={contacts} showContactAction={showContactAction} />
      </Collapse>
    </div>
  );
};

ContactCard.propTypes = {
  profile: PropTypes.object,
  isUserLoggedIn: PropTypes.bool,
  showShare: PropTypes.bool,
  showAdd: PropTypes.bool,
  showEdit: PropTypes.bool,
  loggedInUser: PropTypes.object
};

ContactCard.defaultProps = {
  showContacts: true,
  showShare: false,
  showAdd: true,
  showEdit: true
};

export default ContactCard;



// WEBPACK FOOTER //
// ./src/components/ContactCard/ContactCard.jsx